<template>
  <nav class="navbar navbar-toggleable-md navbar-light bg-faded">
  
    <a class="navbar-brand" href="#">CSV 2 Email</a>

    <div class='pull-right'>Easily send hundreds of mails via CSV</div>
  </nav>
</template>

<script>

export default {
  name: 'site-header',
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  directives: {
  },
};
</script>



// WEBPACK FOOTER //
// SiteHeader.vue?20499ec0